export enum DomainsVerifiable {

  instagram = 'www.instagram.com',
  ozon = 'www.ozon.ru',
  vkontakte = 'vk.com',
  wildberries = 'www.wildberries.ru'

}
